import { defineStore } from 'pinia'
import { type AuthenticationData, type DirectusUser } from '@directus/sdk'

type TStoreType = {
  auth: AuthenticationData | undefined;
  user: DirectusUser | undefined;
};

export const useUserStore = defineStore('user', {
  state: (): TStoreType => {
    return {
      auth: undefined,
      user: undefined
    }
  },
  actions: {
    setAuth (authData: AuthenticationData | undefined) {
      this.$state.auth = authData
    },
    setUser (userData: DirectusUser | undefined) {
      this.$state.user = userData
    }
  },
  getters: {
    getAuth: state => state.auth,
    getUser: state => state.user
  },
  // sessionStorage: the editor tokens are gone when the tab closes and not shared with other tabs
  persist: {
    storage: {
      getItem: key => (import.meta.client ? window.sessionStorage.getItem(key) : null),
      setItem: (key, value) => { if (import.meta.client) { window.sessionStorage.setItem(key, value) } }
    }
  }
  // persist: {
  //   storage: persistedState.cookiesWithOptions({
  //     sameSite: false,
  //     secure: true
  //   }),
  // }
})
